<!-- Young -->
<template>
  <div class="park-ec">
    <public-bread-crumb :routes="routes"></public-bread-crumb>
    <div class="content-wrap">
      <p class="page-title">{{title}}</p>
      <div class="from-wrap">
        <a-spin :spinning="formLoading">
        <a-form style="width: 100%;" :form="formData">
          <a-row>
          <a-col :span="12" :offset="4">
            <a-form-item label="园区名称" :labelCol="{span: 7}" :wrapperCol="{span: 17}" required >
              <a-input
                placeholder="请填写园区名称"
                class="item-input"
                v-decorator="[
                  'name',
                  {
                    validateTrigger: 'blur',
                    rules: [
                      { required: true, message: '请填写园区名称' },
                      { min: 1, max: 64, message: '文字长度限制1~64位'}
                    ]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" :offset="4">
            <a-form-item label="园区系统管理员" :labelCol="{span: 7}" :wrapperCol="{span: 17}" required>
              <a-input
                placeholder="请填写园区负责人"
                class="item-input"
                v-decorator="[
                  'manageName',
                  { validateTrigger: 'blur', rules: [{ validator: checkManageName }] }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" :offset="4">
            <a-form-item label="园区系统管理员账号" :labelCol="{span: 7}" :wrapperCol="{span: 17}" required>
              <a-input
                placeholder="请填写园区负责人电话"
                class="item-input"
                v-decorator="[
                  'managePhone',
                  {
                    validateTrigger: 'blur',
                    rules: [{ validator: checkPhone }]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" :offset="4">
            <a-form-item label="所在区域" :labelCol="{span: 7}" :wrapperCol="{span: 17}" required>
              <gl-area
                placeholder="请选择所在区域"
                class="item-input"
                v-decorator="['address', { rules: [{ required: true, message: '请选择区域' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" :offset="4">
            <a-form-item label="详细地址" :labelCol="{span: 7}" :wrapperCol="{span: 17}" required>
              <a-input
                placeholder="请填写详细地址"
                class="item-input"
                v-decorator="[
                  'detailedAddress',
                  { validateTrigger: 'blur', rules: [{ validator: checkAddress }] }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" :offset="4">
            <a-form-item label=" 园区系统运维账号" :labelCol="{span: 7}" :wrapperCol="{span: 17}" required>
              <a-input
                placeholder="请填写园区运维账号"
                class="item-input"
                v-decorator="[
                  'account',
                  {
                    validateTrigger: 'blur',
                    rules: [
                      { validator: checkDevOps }
                    ]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" :offset="4">
            <a-form-item label="园区系统运维账号密码" :labelCol="{span: 7}" :wrapperCol="{span: 17}" required>
              <a-input
                placeholder="请填写园区运维账号密码"
                class="item-input"
                v-decorator="[
                  'password',
                  {
                    validateTrigger: 'blur',
                    rules: [
                      { validator: checkDevOpsPwd }
                    ]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" :offset="4">
            <a-form-item label="记录保存时限" :labelCol="{span: 7}" :wrapperCol="{span: 17}" required>
              <a-select
                class="item-input"
                v-decorator="['recordTimeLimit', { initialValue: 1, rules: [{ required: true, message: '请选择记录保存时限' }] }]"
                :options="timeRanges"
                >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <div class="btn-wrap">
              <a-button type="primary" class="tool-btn" style="margin-right: 32px;" @click="handleSubmit(false,$event)" :loading="btnLoading">保存</a-button>
              <a-button v-if="!id" type="primary" class="tool-btn" style="margin-right: 32px;" @click="handleSubmit(true,$event)" >继续新增</a-button>
              <a-button class="tool-btn" style="color: #5862CB; background: #ECEDFF;" @click="$router.push('/park')" >取消</a-button>
            </div>
          </a-col>
          </a-row>
        </a-form>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<script>
import ParkServices from '@/services/park.services'

export default {
  name: 'ParkEC',
  data () {
    return {
      id: '',
      title: '新增园区',
      btnLoading: false,
      formLoading: false,
      formData: this.$form.createForm(this, { name: 'parkForm' }),
      routes: [
        {
          name: '园区管理',
          path: '/park'
        },
        {
          name: '新增园区',
          path: ''
        }
      ],
      timeRanges: [
        { label: '1个月', value: 1 },
        { label: '3个月', value: 3 },
        { label: '6个月', value: 6 },
        { label: '1年', value: 12 },
        { label: '2年', value: 24 }
      ]
    }
  },
  mounted () {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.getInfo()
      this.title = '编辑园区'
      this.routes[this.routes.length - 1].name = '编辑园区'
    }
  },
  methods: {
    // 园区系统管理员校验
    checkManageName (rule, value, callback) {
      let reg = /^[0-9A-Za-z\s\u4e00-\u9fa5]{1,64}$/
      if (!value || (value && !reg.test(value))) {
        callback(new Error('请填写园区负责人名称，长度需在1~64位'))
      } else {
        callback()
      }
    },

    // 园区系统管理员账号校验
    async checkPhone (rule, value, callback, txt1) {
      let reg = /^1[345789][0-9][0-9]\d{7}$/
      if (value && !reg.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else if (!value) {
        callback(new Error('请填写园区负责人电话'))
      } else {
        callback()
      }
    },

    // 详细地址校验
    checkAddress (rule, value, callback) {
      let reg = /^[0-9A-Za-z\s\u4e00-\u9fa5]{1,64}$/
      // let reg = /^[0-9A-Za-z\s]*$/
      if (!value || (value && !reg.test(value))) {
        callback(new Error('请填写园区详细地址，长度需在1~64位'))
      } else {
        callback()
      }
    },

    // 园区系统运维账号校验
    checkDevOps (rule, value, callback) {
      let reg = /^[0-9A-Za-z\s]{5,16}$/
      if (!value || (value && !reg.test(value))) {
        callback(new Error('请填写5~16园区运维账号,由数字和字母组成'))
      } else {
        callback()
      }
    },

    // 园区系统运维账号密码校验
    checkDevOpsPwd (rule, value, callback) {
      let reg = /^[0-9A-Za-z\s_!@#$%^&*()]{8,16}$/
      // let reg = /^[0-9A-Za-z_!@#$%^&*()]{8,16}$/
      // let reg2 = /^[^\s]*$/g
      if (!value || (value && !reg.test(value))) {
        callback(new Error('请填写8~16园区运维账号密码'))
      } else {
        callback()
      }
    },

    // 编辑获取数据
    async getInfo () {
      this.formLoading = true
      let res = await ParkServices.GetInfo({ id: this.id })
      this.formLoading = false
      if (res.status === 0) {
        res.result.address = res.result.address.split(',')
        res.result.id = undefined
        this.formData.setFieldsValue(res.result)
      }
    },
    /**
    * 提交表单
    */
    handleSubmit (status = false, e) {
      e.preventDefault()
      this.formData.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          values.address = values.address.join()
          let res
          this.btnLoading = true
          if (this.id) {
            res = await ParkServices.Update({
              id: this.id,
              ...values
            })
          } else {
            res = await ParkServices.Add(values)
          }
          this.btnLoading = false
          if (res.status === 0) {
            let desc = this.id ? '修改成功' : '添加成功'
            this.notification('success', '成功', desc)
            if (status) {
              this.formData.resetFields()
            } else {
              this.$router.push('/park')
            }
          }
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
// @import url(); 引入公共css类
.park-ec {
  .content-wrap {
    height: 891px;
    margin: 0 16px 16px;
    padding: 24px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    .page-title {
      font-size: 18px;
      color: #5862cb;
      margin-bottom: 140px !important;
    }
    .from-wrap {
      flex: 1;
      display: flex;
      justify-content: center;
      .item-text {
        height: 108px !important;
      }
      .btn-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        .tool-btn {
          width: 88px;
          height: 32px;
          border-radius: 3px;
        }
      }
    }
  }
}
</style>
